// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vvVf","controls":"styles_controls__24fZk","charLimit":"styles_charLimit__vfBjq","input":"styles_input__1w-hW","send":"styles_send__3mfYt"};